export const getArticleEditPageUrl = (articleId: string): string => `/editor/${articleId}`;
